import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { editCvCredit, getCvCredit } from 'store/slices';
import Button from 'components/form/Button';
import TextInput from 'components/form/TextInput';
import TextArea from 'components/form/TextArea';
import Loader from 'components/Layout/Loader';

const CreditDetails = () => {
  const dispatch = useDispatch();
  const [creditVal, setCreditVal] = useState([]);
  const [aiPrompts, setAiPrompts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGet, setIsLoadingGet] = useState(false);

  const fetchCredit = async () => {
    setIsLoadingGet(true);
    const res = await dispatch(getCvCredit());
    if (res?.status === 200) {
      setCreditVal(res?.data?.ai_credits || []);
      setAiPrompts(res?.data?.ai_prompts || []);
    } else {
      setCreditVal([]);
      setAiPrompts([]);
    }
    setIsLoadingGet(false);
  };

  useEffect(() => {
    fetchCredit();
  }, []);

  const initialValues = {
    ...creditVal.reduce((acc, curr, index) => {
      acc[`points${index}`] = curr.points;
      return acc;
    }, {}),
    studentPrompt:
      aiPrompts.find((p) => p.user_type === 'student')?.ai_prompts || '',
    professionalPrompt:
      aiPrompts.find((p) => p.user_type === 'professional')?.ai_prompts || '',
  };

  const validationSchema = Yup.object().shape({
    ...creditVal.reduce((acc, curr, index) => {
      acc[`points${index}`] = Yup.number()
        .required('Required')
        .min(0, 'Cannot be negative');
      return acc;
    }, {}),
    studentPrompt: Yup.string().required('Required'),
    professionalPrompt: Yup.string().required('Required'),
  });

  const handleUpdateCredit = async (values, { resetForm }) => {
    setIsLoading(true);
    const transformedData = creditVal.map((item, index) => ({
      id: item.id,
      plan_id: item.plan_id,
      points: Number(values[`points${index}`]) || 0,
    }));

    const updatedPrompts = aiPrompts.map((prompt) => ({
      id: prompt.id,
      updated_by: prompt.updated_by,
      user_type: prompt.user_type,
      ai_prompt:
        prompt.user_type === 'student'
          ? values.studentPrompt
          : values.professionalPrompt,
    }));

    const formData = new FormData();
    formData.append('points_data', JSON.stringify(transformedData));
    formData.append('ai_propmts', JSON.stringify(updatedPrompts));

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const res = await dispatch(editCvCredit(formData));
    if (res?.status === 200) {
      fetchCredit();
      resetForm();
    }
    setIsLoading(false);
  };

  return isLoadingGet ? (
    <div className="center-flex cpt-50 cpb-50">
      <Loader size="md" />
    </div>
  ) : (
    <Formik
      enableReinitialize
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleUpdateCredit}
    >
      {({ values, errors, setFieldValue, handleSubmit, dirty, isValid }) => (
        <form className="row">
          {creditVal.map((ele, index) => (
            <div className="col-md-6 cmb-24" key={ele.id || index}>
              <TextInput
                type="number"
                label={ele.plan_name.replace('-', ' ')}
                id={`points${index}`}
                value={values[`points${index}`]}
                onChange={(e) =>
                  setFieldValue(`points${index}`, e.target.value)
                }
                error={errors[`points${index}`]}
              />
            </div>
          ))}

          <div className="col-md-12 cmb-24">
            <TextArea
              label="Student AI Prompt"
              id="studentPrompt"
              value={values.studentPrompt}
              onChange={(e) => setFieldValue('studentPrompt', e.target.value)}
              error={errors.studentPrompt}
              rows={5}
            />
          </div>

          <div className="col-md-12 cmb-24">
            <TextArea
              label="Professional AI Prompt"
              id="professionalPrompt"
              value={values.professionalPrompt}
              onChange={(e) =>
                setFieldValue('professionalPrompt', e.target.value)
              }
              error={errors.professionalPrompt}
              rows={5}
            />
          </div>

          <div className="d-flex align-items-center gap-3">
            <Button
              text="Update"
              btnStyle="primary-dark"
              className="h-35 cps-15 cpe-12"
              onClick={handleSubmit}
              btnLoading={isLoading}
              disabled={!isValid || !dirty || isLoading}
            />
          </div>
        </form>
      )}
    </Formik>
  );
};

export default CreditDetails;
